import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import FileUploadArea from '../../common/FileUploadArea'
import { DOCUMENTS, DOCUMENTS_BY_TYPE, DOCUMENT_ACCEPT, MAX_DOCUMENT_MB, isFileTooBig } from '../marketplaceConstants'

const DocumentUpload = ({ type, file, required, current, error, onChange }) => {
  const [preview, setPreview] = useState(null)
  const document = DOCUMENTS[type]

  useEffect(() => {
    if (!file) {
      setPreview(null)
      return undefined
    }
    if (file.type === 'application/pdf') {
      setPreview('pdf')
      return undefined
    }
    const url = URL.createObjectURL(file)
    setPreview(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  return (
    <div className="mb-4">
      <FileUploadArea
        label={document.label}
        accept={DOCUMENT_ACCEPT}
        required={required && !current}
        preview={preview}
        fileName={file?.name}
        error={error}
        onChange={({ target }) => {
          const selected = target.files?.[0]
          target.value = ''
          if (selected) onChange(type, selected)
        }}
        onRemove={() => onChange(type, null)}
      />
      <small className="text-600 d-block">{document.help}</small>
      {current && !file && (
        <small className="d-block mt-1 text-700">
          <FontAwesomeIcon icon={faCheckCircle} className="text-success mr-1" />
          Ya cargado: {current.original_name} · {moment(current.updated_at).format('DD/MM/YYYY')}
        </small>
      )}
    </div>
  )
}

const ProviderDocumentsFields = ({ providerType, files, onChange, errors = {}, currentDocuments = [] }) => {
  const [sizeErrors, setSizeErrors] = useState({})
  const { required, optional } = DOCUMENTS_BY_TYPE[providerType] || { required: [], optional: [] }

  const handleChange = (type, file) => {
    if (file && isFileTooBig(file, MAX_DOCUMENT_MB)) {
      setSizeErrors((prev) => ({ ...prev, [type]: `El archivo pesa más de ${MAX_DOCUMENT_MB} MB.` }))
      return
    }
    setSizeErrors((prev) => ({ ...prev, [type]: null }))
    onChange(type, file)
  }

  return [...required, ...optional].map((type) => (
    <DocumentUpload
      key={type}
      type={type}
      file={files[type]}
      required={required.includes(type)}
      current={currentDocuments.find((document) => document.type === type)}
      error={sizeErrors[type] || errors[type]}
      onChange={handleChange}
    />
  ))
}

export default ProviderDocumentsFields
